import { Component, EventEmitter, Input, Output } from "@angular/core";

/**
 * Generated class for the FastToolComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "fast-tool",
  templateUrl: "fast-tool.html",
})
export class FastToolComponent {
  @Input() readonly: boolean = false;
  @Output() onValueUpdate: EventEmitter<any> = new EventEmitter();

  value;

  rows = [
    {
      stage: "1",
      description: "fastStage1",
    },
    {
      stage: "2",
      description: "fastStage2",
    },
    {
      stage: "3",
      description: "fastStage3",
    },
    {
      stage: "4",
      description: "fastStage4",
    },
    {
      stage: "5",
      description: "fastStage5",
    },
    {
      stage: "6a",
      description: "fastStage6a",
    },
    {
      stage: "6b",
      description: "fastStage6b",
    },
    {
      stage: "6c",
      description: "fastStage6c",
    },
    {
      stage: "6d",
      description: "fastStage6d",
    },
    {
      stage: "6e",
      description: "fastStage6e",
    },
    {
      stage: "7a",
      description: "fastStage7a",
    },
    {
      stage: "7b",
      description: "fastStage7b",
    },
    {
      stage: "7c",
      description: "fastStage7c",
    },
    {
      stage: "7d",
      description: "fastStage7d",
    },
    {
      stage: "7e",
      description: "fastStage7e",
    },
    {
      stage: "7f",
      description: "fastStage7f",
    },
  ];

  constructor() {
    // console.log('Hello FastToolComponent Component');
  }

  @Input() set existingData(data: object) {
    // console.log( "Tool received existing data: ", data );
    if (data !== undefined && data != null) {
      this.value = data["value"];
    }
  }

  valueChanged(value: number) {
    if (!this.readonly) {
      // console.log( "Value changed: ", value );
      this.value = value;
      this.onValueUpdate.emit({
        value: this.value,
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/fast-tool/fast-tool.ts